import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { CuentasJardinModel, CuentasModel, ResponseCuentasModel } from 'src/app/model/Cuentas.model';
import { apiService } from 'src/app/service/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-apelaciones-seguimiento',
  templateUrl: './apelaciones-seguimiento.component.html',
  styleUrls: ['./apelaciones-seguimiento.component.css']
})
export class ApelacionesSeguimientoComponent implements OnInit {


  
  displayedColumns=[];
  filterValues = {};
  filterSelectObj = [];
  tipoCampos = [];
  arrayComunas = [];
  regiones = [];
  programas = [];
  dataSource: MatTableDataSource<CuentasJardinModel>;
  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  pageEvent: PageEvent;
  pageIndex:number;
  length:number;
  getSelect = false;
  apiEndpoint = environment.apiEndpoint;
  columnNames = [
    { id: 'region', value: 'region' }, 
    { id: 'comuna', value: 'comuna' }, 
    { id: 'programa', value: 'programa' }, 
    { id: 'codigo', value: 'codigo' }, 
    { id: 'jardin', value: 'jardin' }, 
    { id: 'puntaje', value: 'puntaje' }, 
    { id: 'egapelados', value: 'egapelados' }, 
    { id: 'fechaApelacion', value: 'fechaApelacion' }, 
    { id: 'estado', value: 'estado' }, 
    { id: 'puntajeFinal', value: 'puntajeFinal' }, 
  ];
  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @Input() infoSelectJardin: CuentasModel;
  constructor(
    private api: apiService,    
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.palabraClave = "";
    this.idRegion = 0;
    this.idComuna = 0;
    this.idPrograma = 0;
    this.getServerData(); 
    this.getSelectCuentas(); 
  }

  getSelectCuentas(){
    this.api.API_POST_getSelectCuentas().subscribe((response: ResponseCuentasModel) => {
      this.infoSelectJardin = response.payload
      this.regiones = this.infoSelectJardin.regiones;
      this.programas = this.infoSelectJardin.programas;
    },
    (err) => {
      console.log(err)
    })
  }
  
  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null );
  }


  public callData(event?:PageEvent){
    this.spinner.show();
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.api.API_POST_getApelacionDetalle(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: any) => {
      this.displayedColumns = this.columnNames.map(x => x.id);
      this.dataSource = new MatTableDataSource<CuentasJardinModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      this.length = response.payload.total;
      this.spinner.hide();
      setTimeout(() => {
        
        this.dataSource.paginator = this.paginator;
        
      }, 1000);
        
    },
    (err) => {
      console.log("error"+err)
    })
  }



  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }
  
  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }


  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }
}
